<template>
  <div>
    <v-dialog v-model="dialog" max-width="70%" persistent>
      <v-card>
        <v-card-title>
          <span>Yêu cầu thiết kế: {{ editedItem.requestTitle + ' - ' + (editedItem.orderUnit ? editedItem.orderUnit.name : 'Không có') }}  </span>
          <v-spacer></v-spacer>
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click="showEventDialog">
                history
              </v-icon>
            </template>
            <span>Thông tin lịch sử</span>
          </v-tooltip>

          <v-icon @click="closeDialog">close</v-icon>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-container align="center">
            <v-row align="start">
              <v-col cols="12" sm="7">
                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.customer_infor') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }}
                  {{ editedDefaultAddress ? editedDefaultAddress.name : editedCustomer.fullname }}
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.phone') }}
                  {{ editedDefaultAddress ? editedDefaultAddress.phone : editedCustomer.phone }}
                </v-row>
                <v-row class="pb-1">
                  {{ $t('detail_request.facebook') }} <a :href="editedCustomer.facebook ? editedCustomer.facebook : ''"
                                                         target="_blank">
                  {{ editedCustomer.facebook ? editedCustomer.facebook : '' }} </a>
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.address') }}
                  {{ this.$addressToString(editedCustomer.defaultAddress) }}
                </v-row>
                <v-row class="pb-4"> {{ $t('detail_request.customer_type') }} {{ editedCustomerType.name }}</v-row>

                <v-row class="font-weight-black pb-2"> {{ $t('detail_request.email_content') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.number_estimate') }}
                  {{ this.$thousandSeprator(editedItem.expected_number) }} chiếc
                </v-row>

                <v-row>Danh sách kiểu áo cần thiết kế:</v-row>

                <v-row v-for="(detail, index) in requestDetails" :key="detail._id">
                  <v-col cols="12" sm="1">
                    {{ index + 1 }}.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.form_style') }} {{ detail.formStyle.name }} <br/>
                    {{ $t('detail_request.material_style') }} {{ createMaterialStyleString(detail) }} <br/>
                    {{ $t('detail_request.note') }} {{ detail.note ? detail.note : '' }}
                  </v-col>
                </v-row>

                <v-row>Thông tin các mặt in:</v-row>
                <v-row>
                  <v-col cols="12" sm="1">
                    1.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.font') }}
                    <div v-html='editedItem.front_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ front_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.front_note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    2.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.behind') }}
                    <div v-html='editedItem.behind_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ behind_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.behind_note }}</div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="1">
                    3.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('detail_request.arm') }}
                    <div v-html='editedItem.arm_content'/>
                    <div>{{ $t('detail_request.print_style') }} {{ arm_printStyle.name }}</div>
                    <div> {{ $t('detail_request.note') }} {{ editedItem.arm_note }}</div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="5">
                <v-card>
                  <v-card-title> {{ $t('detail_request.image') }}</v-card-title>
                  <v-card-text>
                    <v-container align="center" justify="center">
                      <v-row align="center">
                        <v-col cols="12">
                          <span> {{ $t('design_item.front_side') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.front_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.behind') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.behind_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <span> {{ $t('design_item.arm') }} </span>
                        </v-col>
                        <v-col cols="12" v-for="file in editedItem.arm_images" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-toolbar flat>
            <v-spacer> </v-spacer>
            <v-btn color="primary" @click="markUnreadStatus">
              {{ $t('common.mark_unread') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <event-log v-model="eventDialog" :editedItem="editedItem" :type="1" @closeDialog="closeEventDialog"
               v-if="editedItem">
    </event-log>
  </div>
</template>

<script>

import EventLog from "@/components/EventLog";
// import i18n from '@/plugins/i18n';
// import moment from 'moment';
// import VNumericField from "@/components/VNumericField";

export default {
  name: 'design-request-dialog',

  props: {
    // Use "value" to enable using v-model
    value: Boolean,
    editedItem: Object
  },


  data: ()=> ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dialog: false,

    editedCustomer: {},
    editedCustomerType: {},
    editedDefaultAddress: {},
    requestDetails: [],

    front_image: null,
    behind_image: null,
    arm_image: null,

    front_printStyle: {},
    behind_printStyle: {},
    arm_printStyle: {},
    eventDialog: false
  }),

  components: {
    EventLog: EventLog
  },

  computed: {

  },

  watch: {

  },

  mounted () {

  },

  async created () {
    this.dialog = this.value;
    this.editedCustomer = Object.assign({}, this.editedItem.customer)
    this.editedCustomerType = this.editedItem.customerType;
    this.editedDefaultAddress = this.editedItem.customer.defaultAddress;
    this.requestDetails = this.editedItem.request_details;

    // this.front_image = this.baseImage + item.front_image;
    // this.behind_image = this.baseImage + item.behind_image;
    // this.arm_image = this.baseImage  + item.arm_image;

    this.front_printStyle = this.editedItem.front_printStyle;
    this.behind_printStyle = this.editedItem.behind_printStyle;
    this.arm_printStyle = this.editedItem.arm_printStyle;



    // const userType = localStorage.getItem('type');
    // let requestBody = {};
    // if (userType == 1 && this.editedItem.saleReadStatus == 0) {
    //   requestBody.saleReadStatus = 1;
    //   const isSuccess = await this.$updateDesignRequestByUser(requestBody);
    //
    //   if (isSuccess) {
    //     this.editedItem.saleReadStatus = 1;
    //     this.$emit('update', this.editedItem);
    //   }
    // } else if (userType == 2 && this.editedItem.designerReadStatus == 0) {
    //   requestBody.designerReadStatus = 1;
    //   const isSuccess = await this.$updateDesignRequestByUser(requestBody);
    //
    //   if (isSuccess) {
    //     this.editedItem.designerReadStatus = 1;
    //     this.$emit('update', this.editedItem);
    //   }
    // }

    await this.updateStatus(1);
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit('closeDialog', false);
    },

    createMaterialStyleString(detail) {
      return this.$materialStyleString(detail);
    },

    markUnreadStatus() {
      this.updateStatus(0);
      this.closeDialog();
    },

    showEventDialog() {
      this.eventDialog = true;
    },

    closeEventDialog(value) {
      this.eventDialog = value
    },

    async updateStatus(status) {
      const userType = localStorage.getItem('type');
      let requestBody = {};
      if (userType == 1 && this.editedItem.saleReadStatus != status) {
        requestBody.saleReadStatus = status;
        const isSuccess = await this.$updateDesignRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.saleReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      } else if (userType == 2 && this.editedItem.designerReadStatus != status) {
        requestBody.designerReadStatus = status;
        const isSuccess = await this.$updateDesignRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.designerReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      }
    }
  }
}
</script>